import { useCallback } from 'react';
import { Stack, Switch } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Iconify from '../iconify';
import useLocalStorage from '../../hooks/useLocalStorage';
import { useSettingsContext } from '../settings';

function ThemeSwitch() {
  const theme = useTheme();
  const { themeMode, onToggleMode } = useSettingsContext();
  const [settings, setSettings] = useLocalStorage('settings', { themeMode });

  const onToggleModeLocal = useCallback(
    (e: any) => {
      const cThemeMode = settings.themeMode === 'light' ? 'dark' : 'light';
      onToggleMode();
      setSettings({ ...settings, themeMode: cThemeMode });
    },
    [setSettings, settings, onToggleMode]
  );

  return (
    <Stack direction="row" spacing={0} alignItems="center" sx={{ position: 'relative' }}>
      <Iconify
        color={themeMode === 'dark' ? theme.palette.primary.main : theme.palette.text.secondary}
        icon="eva:moon-fill"
        width={16}
      />
      <Switch
        name="themeSwitch"
        size="small"
        color="default"
        checked={themeMode === 'light'}
        onChange={onToggleModeLocal}
        sx={{
          margin: 0,
          justifyContent: 'center',
        }}
      />
      <Iconify
        color={themeMode === 'light' ? theme.palette.primary.main : theme.palette.text.secondary}
        icon="eva:sun-fill"
        width={16}
      />
    </Stack>
  );
}

export default ThemeSwitch;
